import { PackageProviderName } from 'data/ppoints/constants';
import { transformToCdnUrl } from 'utils/google-storage-util';
import base from './tile-art.module.css';
import { ProviderLogoBadge } from './ProviderLogoBadge';
import styles from './ProviderSettingsTileArt.module.css';

export interface ProviderSettingsTileArtProps {
    provider?: PackageProviderName;
}

export const ProviderSettingsTileArt: React.FC<ProviderSettingsTileArtProps> = ({ provider }) => (
    <>
        <img
            className={`${base.layer} ${styles.sheet}`}
            src={transformToCdnUrl('embedded-assets/tiles/provider-settings-tile.webp')}
            width={1244}
            height={929}
            alt=""
            aria-hidden="true"
            loading="lazy"
        />
        {!!provider && <ProviderLogoBadge provider={provider} className={styles.logoBadge} />}
    </>
);
